import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone,FiMail,FiMapPin,FiClock,FiFacebook,FiLinkedin}=FiIcons;

const Footer=()=> {
  const handleScheduleDemo=()=> {
    window.open('https://zcal.co/t/crc/aivoice','_blank');
  };

  const handleComplianceClick=()=> {
    window.open('https://app.delve.co','_blank');
  };

  const handleSocialClick=(url)=> {
    window.open(url,'_blank');
  };

  const handleCRCADClick=()=> {
    window.open('https://clarkritchotte.com/?mtm_campaign=LandingPageRedirect&mtm_placement=footer-logo','_blank');
  };

  const handleLegalClick=(url)=> {
    window.open(url,'_blank');
  };

  const handleRetellClick=()=> {
    window.open('http://crclnk.net/AiVoiceRT','_blank');
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            {/* Compliance Icons replacing AI Voice Pro */}
            <div className="mb-4">
              
            </div>

            <p className="text-gray-300 mb-6">
              Leading provider of AI voice receptionists for NYC and Hudson Valley businesses. Powered by advanced AI technology,we deliver professional call handling solutions that transform customer communications.
            </p>

            <div className="space-y-3">
              <a
                href="tel:+13322324531"
                className="flex items-center gap-3 text-gray-300 hover:text-orange-300 transition-colors"
              >
                <SafeIcon icon={FiPhone} className="w-4 h-4" />
                <span>+1 332-232-4531</span>
              </a>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span className="text-gray-300">sales@clarkritchotte.com</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMapPin} className="w-4 h-4" />
                <span className="text-gray-300">200 Broadway,Floor 3,New York,NY 10038</span>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="mt-6">
              <h5 className="text-sm font-semibold text-gray-300 mb-3">Follow Us</h5>
              <div className="flex gap-4">
                <button
                  onClick={()=> handleSocialClick('https://www.facebook.com/ClarkRitchotte')}
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-300"
                  aria-label="Follow us on Facebook"
                >
                  <SafeIcon icon={FiFacebook} className="w-5 h-5" />
                </button>
                <button
                  onClick={()=> handleSocialClick('https://www.linkedin.com/company/clarkritchotte/')}
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-700 rounded-full flex items-center justify-center transition-colors duration-300"
                  aria-label="Follow us on LinkedIn"
                >
                  <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Try Our Sales Bot CTA */}
            <div className="mt-6 bg-gray-800 rounded-lg p-4 border border-gray-700">
              <p className="text-sm text-gray-300 mb-2">
                Experience our AI technology:
              </p>
              <a
                href="tel:+13322324531"
                className="flex items-center gap-2 text-orange-400 hover:text-orange-300 transition-colors"
              >
                <SafeIcon icon={FiPhone} className="w-4 h-4" />
                <span className="font-medium">Try our AI Sales Bot now</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">AI Voice Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>AI Voice Receptionist</li>
              <li>PBX System Integration</li>
              <li>VoIP Solutions</li>
              <li>Intelligent Call Routing</li>
              <li>CRM Integration</li>
              <li>Multilingual Support</li>
              <li>Appointment Scheduling</li>
              <li>Call Analytics & Reporting</li>
            </ul>
          </div>

          {/* Areas Served */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Manhattan,NYC</li>
              <li>Brooklyn,NYC</li>
              <li>Queens,NYC</li>
              <li>Bronx,NYC</li>
              <li>Staten Island,NYC</li>
              <li>Poughkeepsie,NY</li>
              <li>Kingston,NY</li>
              <li>Newburgh,NY</li>
              <li>White Plains,NY</li>
              <li>Yonkers,NY</li>
              <li>Hudson Valley Region</li>
              <li>Westchester County</li>
            </ul>
          </div>

          {/* Industries & Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Industries We Serve</h4>
            <ul className="space-y-2 text-gray-300 mb-6">
              <li>Medical Practices</li>
              <li>Law Firms</li>
              <li>Real Estate Agencies</li>
              <li>Accounting Firms</li>
              <li>Dental Offices</li>
              <li>Veterinary Clinics</li>
              <li>Professional Services</li>
              <li>Small Businesses</li>
            </ul>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiClock} className="w-4 h-4" />
                <span className="text-gray-300">24/7 Support Available</span>
              </div>
              <button
                onClick={handleScheduleDemo}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full transition-colors duration-300"
              >
                Schedule Demo
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy;2024 Clark-Ritchotte Communications and Affiliated Companies. All rights reserved.</p>
          <p className="mt-2 text-sm">
            Professional AI voice receptionist services serving NYC,Manhattan,Brooklyn,Queens,Bronx,Hudson Valley,Poughkeepsie,Kingston,Westchester County,and surrounding New York areas.
          </p>
          <p className="mt-2 text-sm">
            <a
              href="tel:+13322324531"
              className="text-orange-400 hover:text-orange-300 transition-colors"
            >
              Experience our AI voice technology: +1 332-232-4531
            </a>
          </p>

          {/* Legal Links */}
          <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm">
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/accessibility/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Accessibility
            </button>
            <span className="text-gray-600">|</span>
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/privacy/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Privacy
            </button>
            <span className="text-gray-600">|</span>
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/tos/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              TOS
            </button>
            <span className="text-gray-600">|</span>
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/aup/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              AUP
            </button>
            <span className="text-gray-600">|</span>
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/apt/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Accepted Payment Types
            </button>
            <span className="text-gray-600">|</span>
            <button
              onClick={()=> handleLegalClick('https://corporate.clarkritchotte.com/legal/crp/')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              California Rights Policy
            </button>
          </div>

          {/* Partner Logos - Centered under legal links */}
          <div className="mt-4 flex items-center gap-4 justify-center">
            
            <button
              onClick={handleRetellClick}
              className="opacity-80 hover:opacity-100 transition-opacity"
            >
              <img
                src="https://s3.us-east-2.wasabisys.com/crc-cdn/crc/RetellAi-AP.png"
                alt="Retell AI Authorized Partner"
                className="h-12 w-auto object-contain"
              />
            </button>
            <button
              onClick={handleCRCADClick}
              className="opacity-80 hover:opacity-100 transition-opacity"
            >
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751983148910-CRCAD-logo-Mater-1-png.png"
                alt="CRCAD Logo"
                className="h-12 w-auto object-contain"
              />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;